module.exports = __webpack_public_path__ + "img/images_project_bg3.2e899258.png";